module.exports = __webpack_public_path__ + "img/globe-computer.f630374a.gif";